import React, { useRef, useState } from 'react';
import { Input, Space, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import Button from "components/button";

const { RangePicker } = DatePicker;

const ColumnSearchFilter = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [dateRange, setDateRange] = useState([null, null]); 
  
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex, searchPlaceholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={searchPlaceholder || `Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            extra="crud-button btn-small"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            extra="crud-button btn-small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>          
          <Button
            type="link"
            extra="crud-button btn-small"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      if (Array.isArray(dataIndex)) {
        return dataIndex.some((field) =>
          record[field]
            ?.toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        );
      }

      return record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes(value.toLowerCase());
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const getDateRangeColumnFilter = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <RangePicker
          onChange={(dates) => {
			if (dates) {
		      const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
		      setSelectedKeys([formattedDates]);
		      setDateRange(dates); 
		    } else {
		      setSelectedKeys([]);
		      setDateRange([null, null]);
		    }
          }}
          value={dateRange}
          style={{ marginBottom: 8, display: 'flex' }}
        />
        <Space>
          <Button
            extra="btn-small"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90 }}
          >
            Filter
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              setDateRange([null, null]);
            }}
            extra="btn-small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            extra="btn-small"
            onClick={() => close()}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const [startDate, endDate] = value;
      const recordDate = record[dataIndex];
      return startDate && endDate ? recordDate >= startDate && recordDate <= endDate : true;
    },

  });

 return { getColumnSearchProps, getDateRangeColumnFilter };
};

export default ColumnSearchFilter;
